import React from "react";
import Box from "@mui/material/Box";
import Main from "layouts/Main";
import {
  Hero,
  Customers,
  ConnectionAnimation,
  DashboardShowcase,
  FinalCTA,
} from "./components";

const IndexView = () => {
  return (
    <Box sx={{ overflowX: 'hidden' }}>
      <Main bgcolor={'background.paper'}>
        {/* Hero Section */}
        <Hero />

        {/* Customers Section - Trust Indicators */}
        {/* COMMENTED OUT: Too large for 2 customers, now using inline mini logos in Hero */}
        {/* <Customers /> */}

        {/* Connection Animation - Centerpiece */}
        {/* <ConnectionAnimation /> */}

        {/* Dashboard Showcase */}
        {/* <DashboardShowcase /> */}

        {/* Final CTA */}
        {/* <FinalCTA /> */}
      </Main>
    </Box>
  );
};

export default IndexView;
